import React from 'react';
import { useTranslation } from 'react-i18next';

// ── An account's ROLE on the chart (batch 8 R1 — design §3.2) ─────────────────────────────────────────────────────────
// What the system itself posts to an account for (services/coaRules.ts COA_ROLES): output VAT, retained earnings, the
// parking accounts … The server says which role each account HOLDS (chartOf's roleEffective) and from where
// (roleSource): 'set' — an administrator gave it to this account; 'template' — the account is this chart's copy of the firm
// template account that carries it (D2: nothing was written on the client's row). ⛔ The screen never works a role out
// from a code or a name: it shows what the server sent.
// A template-held role is drawn light, with "from the template"; a set one solid. The payroll and WHT posting maps'
// answers for the account (roleMapped, design §3.5 D3) are shown beside it read-only, in their own screens' words.

const PND1 = 'ภ.ง.ด.1';   // the payroll role words name the form (PayrollSettings.tsx passes the same)

export function RoleBadge({ role, source }: { role: string; source: string }) {
  const { t } = useTranslation();
  if (!role) return null;
  const template = source === 'template';
  return (
    <span data-role-badge={role} data-role-source={source || undefined} title={template ? t('coar_from_template_tip') : t('coar_set_tip')}
      style={{ display: 'inline-flex', alignItems: 'baseline', gap: 4, fontSize: 10.5, fontWeight: 700, borderRadius: 999, padding: '0 7px', lineHeight: '17px',
        whiteSpace: 'normal', ...(template
          ? { border: '1px dashed var(--border-strong)', color: 'var(--text-secondary)', background: 'transparent' }
          : { border: '1px solid #B9D3F0', color: '#1D4E89', background: '#E8F1FB' }) }}>
      <span>{t(`coar_role_${role}`, { defaultValue: role })}</span>
      {template && <span data-role-from-template style={{ fontWeight: 500, fontSize: 9.5, color: 'var(--text-tertiary)' }}>{t('coar_from_template')}</span>}
    </span>
  );
}

/** One answer of the payroll or settlement posting maps naming this account — read only (D3). */
export function MappedRoleBadge({ source, role }: { source: string; role: string }) {
  const { t } = useTranslation();
  const words = source === 'payroll' ? t(`prs_role_${role}`, { form: PND1, defaultValue: role }) : t(`aw_pacc_role_${role}`, { defaultValue: role });
  return (
    <span data-role-mapped={`${source}:${role}`} title={t('coar_mapped_tip')}
      style={{ display: 'inline-block', fontSize: 10, fontWeight: 600, borderRadius: 999, padding: '0 7px', lineHeight: '16px', whiteSpace: 'normal',
        border: '1px solid var(--border)', color: 'var(--text-tertiary)', background: 'var(--bg-app)' }}>
      {t(source === 'payroll' ? 'coar_mapped_payroll' : 'coar_mapped_settlement', { role: words })}
    </span>
  );
}
